export default __webpack_public_path__ + "static/Shumo_Manta-92b335356711d3f18a2b429e52fbf1ea.jpg";